import React from 'react';
import styled from 'styled-components';
import { Loader } from '../../Loader';
import { font } from './sharedStyles';

const Spinner = styled(Loader)`
  position: unset;
`;

const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  margin-top: -104px;
  width: 100%;
`;

const EmptyStateWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  margin-top: -116px;
  color: var(--table-cellrenderer-empty-state-color);
  opacity: 0.435;
  ${font}
`;

export const NoRowsRenderer = ({ isLoading, emptyStateText }: any) => {
  if (isLoading)
    return (
      <SpinnerWrapper>
        <Spinner />
      </SpinnerWrapper>
    );
  if (emptyStateText) return <EmptyStateWrapper>{emptyStateText}</EmptyStateWrapper>;
  return null;
};
